import { fromJS } from 'immutable';
import { createReducer } from '../../../utils';
import { composeResetReducer } from 'redux-reset-store';
import { updateReceiptSyncs, updateSettings, resetStaticApiToken } from '../actions';

const initialState = {
    isLoading: false,
    data_formats: [],
    customer_order_setting: {
        email_configurations: [],
    },
    receipt_syncs: [],
};

export default composeResetReducer(
    createReducer(fromJS(initialState), {
        [updateSettings]: (state, payload) =>
            state.setIn(['customer_order_setting', 'email_configurations'], fromJS(payload) || []),
        [updateReceiptSyncs]: (state, payload) => {
            console.log('updateReceiptSyncs');
            return state.setIn(['receipt_syncs'], fromJS(payload) || []);
        },
        [resetStaticApiToken]: (state, payload) => {
            console.log('resetStaticApiToken');
            console.log("resetStaticApiToken reducer before state: ", state);
            return state.merge({static_api_token: undefined});
        }
    }),
    fromJS(initialState),
    'AUTH_LOGOUTUSER_REQUEST'
);
